import _ from "lodash";
import moment from "moment";
import JobUtils from "./JobsUtils";
import RequestUtils from  "./RequestUtils";
import ConfigUtils from "./ConfigUtils";

export default class SummaryUtils {

  static getRevealComponents(revealFields, parentValue) {
    let components = [];
    revealFields.forEach((revealField) => {
      if (revealField && revealField.refData) {
        components = (revealField.refData === parentValue) ? revealField.components : components;
      } else {
        components = revealField.components;
      }
    });
    return components;
  }

  static getHeaders(fields = {}, data) {
    let renderFields = [];
    let metaData = _.get(fields, "metadata") || [];
    let displayFields = [...metaData];
    let overrideReadOnlyMetadata = _.get(fields, "overrideReadOnlyMetadata") || [];
    let overrideMetadata = _.get(fields, "overrideMetadata") || [];
    const inputComponents = ConfigUtils.getInputComponents();
    const inputComp = _.get(inputComponents, "inputComponents[0].dataFields[0]");

    const renderDisplayFields = (inputField,revealComponents) => {
      if(revealComponents && revealComponents.length > 0) {
        if(inputField.additionalMetadataPosition) {
          let displayAdditionalMetadataFields = [...displayFields];
          const position = _.get(inputField,'additionalMetadataPosition');
          displayAdditionalMetadataFields.splice(position, 0, ...revealComponents);
          return displayAdditionalMetadataFields;
        }else {
          const displayOtherFields = [...displayFields, ...revealComponents];
          return displayOtherFields;
        }
      }else {
        return displayFields
      }
    }
    
    // Below code will attach reveal components also in the list so that we can show them in summary.
    metaData.forEach((field) => {
        let inputField = _.get(inputComp, field);
        if (inputField && inputField.reveal) {
          let revealComponents = SummaryUtils.getRevealComponents(inputField.reveal, data[field]);
          displayFields = renderDisplayFields(inputField,revealComponents);
        }
    });
    
    _.map(displayFields, (displayField) => {
      let overrideField = _.get(overrideMetadata && overrideMetadata[0], displayField);
      let noShow = (_.has(overrideField, "showSummary") && _.get(overrideField, "showSummary") === false);
      let field = _.get(inputComp, displayField);
      if (!noShow) {
        renderFields.push({
          label: (overrideField && overrideField.summaryLabel) ? overrideField.summaryLabel :  field.label,
          color: field.color,
          fields: [
            {
              type: field.type,
              value: displayField
            },
          ],
        });
      }
    });

    let readOnlyMetadata = _.get(fields, "readOnlyMetadata");

    if (readOnlyMetadata && readOnlyMetadata.length > 0) {
      // Later if we introduce override for readOnlyMetadata then we can add that also.
      const readComp = _.get(ConfigUtils.getReadOnlyComponents(), "readOnlyComponents.dataFields");
      _.map(readOnlyMetadata, (readField) => {
        let overrideField = _.get(overrideReadOnlyMetadata && overrideReadOnlyMetadata[0], readField);
        let noShow = (_.has(overrideField, "showSummary") && _.get(overrideField, "showSummary") === false);
        let field = _.get(readComp, readField);
        if(!noShow) {
          renderFields.push({
            label: (overrideField && overrideField.label) ? overrideField.label :  field.label,
            fields: [
              {
                type: field.type,
                value: (overrideField && overrideField.value ? overrideField.value : "readOnlyMetadata." + readField)
              },
            ]
          });
        }
      });
    }
    return renderFields;
  }

  static getProcessorHeaders(job, value) {
    let selectedJobType = JobUtils.extractJobTypeObjectByValue(_.get(job, "jobType"))
    let selectedProcessType = JobUtils.getSelectedProcessingType(job);

    return SummaryUtils.getHeaders({
      metadata: _.isEmpty(selectedProcessType) ? [] : _.get(selectedProcessType, "metadata"),
      overrideMetadata: _.get(_.get(selectedJobType, "processingInput"), "override.metadata"),
      readOnlyMetadata: _.get(_.get(selectedJobType, "processingInput"), "readOnlyMetadata"),
      overrideReadOnlyMetadata:_.get(_.get(selectedJobType, "processingInput"), "override.readOnlyMetadata"),
    }, value);
  }

  static getDeliveryLabel(delivery) {
    const deliveryOption = _.get(delivery, "deliveryOption");
    const deliveryMethod = _.find(ConfigUtils.getDeliveryTypes(), (deliveryData) => {
      return _.camelCase(_.get(deliveryData, "label")) === _.camelCase(deliveryOption);
    });
    return _.get(deliveryMethod, "label");
  }

  // We will remove it in future as we do not need it anymore.
  // Keeping it for references.
  static getDeliveryHeaders(delivery) {
    let deliveryField = [];
    const inputComponents = ConfigUtils.getInputComponents();
    const inputComp = _.get(inputComponents, "inputComponents[0].dataFields[0]");
    _.map(delivery, (_meta, key) => {
      let field = _.get(inputComp, key);
      if (!_.isEmpty(field)) {
        deliveryField.push({
          label: field.label,
          fields: [
            {
              type: field.type,
              value: key,
            },
          ],
        });
      }
    });
    return deliveryField;
  }

  static getValue = (fields, data) => {
    const value = fields.map((field) => {
      const type = field.type;
      const fieldValue = field.value;
      switch (type) {
        case "email":
          return _.isArray(fieldValue)
            ? _.map(fieldValue, (val) => {
                return _.get(data, val, "");
              }).join("\n")
            : _.isArray(_.get(data, fieldValue, ""))
            ? _.get(data, fieldValue).join(", ")
            : _.get(data, fieldValue);
        case "text":
          // Special handling for one of the  value, we may need to move it at root level.
          if (fieldValue === 'profile.description') {
            const fileType = _.get(data, fieldValue);
            return RequestUtils.getFileTypeLabel(fileType);
          }
          return _.get(data, fieldValue, "");
        case "id":
          return JobUtils.transformJobId(_.get(data, fieldValue, ""));
        case "cc":
          return _.get(data, fieldValue, "").join(", ");
        case "boolean":
          return _.get(data, fieldValue, false) ? "Yes" : "No";
        case "date":
          return moment(_.get(data, fieldValue, "")).format("MM/DD/YY");
        case "dateTime":
          return moment(_.get(data, fieldValue, "")).format("MM/DD/YY hh:mm A");
        case "name":
          const textData = _.map(fieldValue, (val) => {
            return _.get(data, val, "");
          });
          return textData.join(" ");
        case "time":
          return moment(_.get(data, fieldValue, ""), 'HH:mm').format('hh:mm A');
        case "files":
          return _.size(_.get(data, fieldValue));
        default:
          if(fieldValue === "s3Destination") {
            return _.get(data, "account", "");
          }
          return _.get(data, fieldValue, "");
      }
    });
    return value.join(" ");
  };
  static hasEmptyFields = (fields, data) => {
    let isEmpty = true;
    fields.forEach((field) => {
      if (_.get(data, field.value) || field.value === 'readOnlyMetadata.hasCaptions' || field.value === 'shareable') {
        isEmpty = false;
        return;
      }
      if (_.isArray(field.value)) {
        _.map(field.value, (val) => {
          if (!_.isEmpty(_.get(data, val))) {
            isEmpty = false;
          }
        });
      }
    });
    return isEmpty;
  };
  static transformFilesCount = (sourceFiles) => {
    const filesMap = {};
    _.forEach(sourceFiles, (file) => {
      const fileExtension = file.substring(file.lastIndexOf('.') + 1);
      if (filesMap[fileExtension]) {
        filesMap[fileExtension].push(file);
      } else {
        filesMap[fileExtension] = [file];
      }
    });
    const arrFiles = Object.entries(filesMap).map(([n,v])=>({extension:n,files:v}));
    return arrFiles;
  }
}
